import { Button, Card, Collapse, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Props } from './props';
import { RowLine, LabelRow, SpanBlock, ContainerNota } from './styles';
import iconcoleta from '../../../../../../../assets/img/coleta.svg';
import iconentrega from '../../../../../../../assets/img/entrega.svg';
import { maskCurrency, maskUnd } from '../../../../../../../utils/mask';
import anexo from '../../../../../../../assets/img/anexar.svg';
import { SKW_PREFIX } from '../../../../../../../utils/constants';
import Swal from 'sweetalert2';
import api from '../../../../../../../service/api';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import saveAs from 'file-saver';

const ModalDetalhes: React.FC<Props> = ({
  isModalVisible,
  setIsModalVisible,
  detalhesAgendamento,
  pedidosOrdemCarga,
  confirmLoading,
}) => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [loading, setLoading] = useState<boolean>(false);
  const { Panel } = Collapse;
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [detalhesAgendamento]);

  const onChange = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  function downloadAnexos(nuNota: number) {
    return api
      .post(
        `call?serviceName=${SKW_PREFIX}baixarAnexoNota&token=${token}`,
        {
          nunota: nuNota,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], {
          type: 'application/octet-stream',
        });
        const filename = 'nota-agendamento.zip';
        saveAs(blob, filename);
        Swal.fire({
          title: `Download efetuado com sucesso!`,
          html: '',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: `Não foi possível efetuar o download.`,
          html: '',
          icon: 'error',
          showConfirmButton: true,
          // timer: 2000,
        });
      });
  }

  return (
    <>
      <Modal
        title={'Detalhes do agendamento nº ' + detalhesAgendamento?.codAgendamento}
        visible={isModalVisible}
        footer={[]}
        onCancel={handleCancel}
        className="themeModalConsultaAgendamento"
      >
        <Card title={''}>
          <RowLine>
            <p>
              <LabelRow>Tipo de agendamento</LabelRow>{' '}
              <SpanBlock>
                {
                  <>
                    <img
                      src={detalhesAgendamento?.tipoWms === 'EXP' ? iconcoleta : iconentrega}
                      alt="icone do agendamento"
                      style={{ marginRight: '5px' }}
                    />
                    {detalhesAgendamento?.tipoWms === 'EXP' ? 'Coleta' : 'Entrega'}
                  </>
                }
              </SpanBlock>
            </p>
            <p>
              <LabelRow>Status</LabelRow>{' '}
              <SpanBlock>
                {
                  <span
                    style={{
                      color: detalhesAgendamento?.status === 'AGE' ? '#1890ff' : '#B45309',
                    }}
                  >
                    {detalhesAgendamento?.status === 'AGE' ? 'Agendado' : 'Expedido'}
                  </span>
                }
              </SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Nome do Cliente</LabelRow>
              <SpanBlock>{detalhesAgendamento?.cliente}</SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Data</LabelRow>{' '}
              <SpanBlock>{detalhesAgendamento?.dhAgendamento?.split(' ')[0]}</SpanBlock>
            </p>
            <p>
              <LabelRow>Hora</LabelRow>{' '}
              <SpanBlock>{detalhesAgendamento?.dhAgendamento?.split(' ')[1]}</SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Trasportadora</LabelRow>{' '}
              <SpanBlock>{detalhesAgendamento?.transportadora}</SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Motorista</LabelRow> <SpanBlock>{detalhesAgendamento?.motorista}</SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Veículo</LabelRow>{' '}
              <SpanBlock>
                {detalhesAgendamento?.tipVei + ' - ' + detalhesAgendamento?.placa?.toUpperCase()}
              </SpanBlock>
            </p>
          </RowLine>
          <RowLine>
            <p>
              <LabelRow>Peso Bruto Total</LabelRow>{' '}
              <SpanBlock>{maskUnd(detalhesAgendamento?.pesoBruto) + ' KG'}</SpanBlock>
            </p>

            <p>
              <LabelRow>Valor Total</LabelRow>{' '}
              <SpanBlock>{maskCurrency(detalhesAgendamento?.valor)}</SpanBlock>
            </p>
          </RowLine>
        </Card>

        <Collapse onChange={onChange}>
          <Panel header="Documento(s)" key="1">
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '20px auto',
                }}
              >
                <Spin tip="Carregando..." />
              </div>
            ) : (
              pedidosOrdemCarga.map((item: any) => (
                <ContainerNota>
                  <RowLine style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>
                      <LabelRow>Nº da NF</LabelRow> <SpanBlock>{item?.numNota}</SpanBlock>
                    </p>
                    {item?.temAnexo && (
                      <p>
                        <LabelRow>Anexo</LabelRow>{' '}
                        <SpanBlock>
                          <img
                            src={anexo}
                            alt="ícone de anexo"
                            style={{ width: '30px' }}
                            onClick={() => downloadAnexos(item?.nuNota)}
                          />
                        </SpanBlock>
                      </p>
                    )}
                  </RowLine>
                  <RowLine>
                    <p>
                      <LabelRow>Fornecedor</LabelRow> <SpanBlock>{item?.fornecedor}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <LabelRow>Peso Bruto</LabelRow>{' '}
                      <SpanBlock>{maskUnd(item?.pesoBruto) + ' KG'}</SpanBlock>
                    </p>
                    <p>
                      <LabelRow>Valor</LabelRow> <SpanBlock>{maskCurrency(item?.valor)}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <LabelRow>Observação</LabelRow> <SpanBlock>{item?.observacao}</SpanBlock>
                    </p>
                  </RowLine>
                </ContainerNota>
              ))
            )}
          </Panel>
        </Collapse>

        <Button type="primary" onClick={handleOk} style={{ width: '100%', marginTop: '20px' }}>
          OK
        </Button>
      </Modal>
    </>
  );
};

export default ModalDetalhes;
